import React from 'react';
import { Spinner } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Sizes = () => {
  return (
    <>
      <h4 className="mt-5">Sizes</h4>
      <p>
       The size of the spinners can be changed by passing a number to the <i>size</i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <Spinner className="single-btn" size={40} />
        <Spinner className="single-btn" type="success" size={65} />
        
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Spinner } from "chic-ui";'}
          <br />
          {'<Spinner size={40} />'}
          <br />
          {'<Spinner type="success" size={65} />'}
        </code>
      </Row>
    </>
  );
};

export default Sizes;
